<template>
  <div class="TenantManagement">
    <el-form :inline="true"
             :model="searchForm"
             @keyup.enter.native="getDataList('search')">
      <el-form-item label="房间号">
        <el-select v-model="searchForm.apartmentAssetCode"
                   @change="getDataList('search')">
          <el-option v-for="item in homeList"
                     :key="item.apartmentAssetCode"
                     :label="item.apartmentAssetName"
                     :value="item.apartmentAssetCode" />
        </el-select>
      </el-form-item>
      <el-form-item label="租户名称">
        <el-input v-model="searchForm.apartmentUserName"
                  placeholder="租户名称"></el-input>
      </el-form-item>
      <el-form-item label="手机号">
        <el-input v-model="searchForm.phone"
                  placeholder="手机号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search"
                   size="small"
                   type="primary"
                   @click="getDataList('search')">搜索
        </el-button>
        <el-button icon="el-icon-delete"
                   size="small"
                   plain
                   type="primary"
                   @click="reset()">清空
        </el-button>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-button icon="el-icon-plus"
                     size="small"
                     type="primary"
                     @click="openModifyDialog()">添加租户
          </el-button>
        </el-col>
      </el-row>
    </el-form>
    <el-tabs v-model="activeName"
             @tab-click="handleClick"
             style="margin-top: 20px;">

      <el-tab-pane :label="item.apartmentName"
                   :name="item.apartmentCode"
                   v-for="(item, index) in apartmentlist"
                   :key="index">

        <el-table class="dataTable"
                  v-loading="dataListLoading"
                  :data="dataList"
                  :header-cell-style="{'text-align':'center'}"
                  :cell-style="{'text-align':'center'}"
                  border>
          <el-table-column label="租户名称"
                           prop="apartmentUserName">
          </el-table-column>
          <el-table-column label="手机号"
                           prop="phone">
          </el-table-column>
          <el-table-column label="创建时间"
                           prop="createdTime">
          </el-table-column>
          <el-table-column label="操作"
                           width="400">
            <template slot-scope="scope">
              <el-button size="mini"
                         type="primary"
                         @click="openDetailDialog(scope.row)">查看</el-button>
              <el-button size="mini"
                         type="primary"
                         @click="openModifyDialog(scope.row)">编辑</el-button>
              <el-button size="mini"
                         type="danger"
                         @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination :current-page="pageIndex"
                       :page-size="pageSize"
                       :page-sizes="[10, 20, 50, 100]"
                       :total="totalPage"
                       background
                       layout="total, sizes, prev, pager, next, jumper"
                       @size-change="sizeChangeHandle"
                       @current-change="currentChangeHandle">
        </el-pagination>
      </el-tab-pane>
    </el-tabs>

    <!-- 新增&修改租户信息 -->
    <el-dialog :title="modifyForm.apartmentAssetCode ? '修改租户信息' : '添加租户'"
               :visible.sync="modifyDialog"
               width="40%"
               :before-close="cancelModifyDialog">
      <el-form class="modifyForm"
               ref="modifyForm"
               :model="modifyForm"
               :rules="modifyRule"
               label-width="40%">
        <el-form-item label="租户名称"
                      prop="apartmentUserName">
          <el-input style="width: 200px;"
                    v-model="modifyForm.apartmentUserName"
                    placeholder="请输入租户名称"
                    @keyup.enter.native="modifyHandle()"></el-input>
        </el-form-item>
        <el-form-item label="手机号"
                      prop="phone">
          <el-input style="width: 200px;"
                    v-model="modifyForm.phone"
                    placeholder="请输入租户名称"
                    @keyup.enter.native="modifyHandle()"></el-input>
        </el-form-item>

      </el-form>
      <span slot="footer"
            class="dialog-footer"
            style="display: flex;justify-content: space-between">
        <el-button @click="cancelModifyDialog()">取 消</el-button>
        <el-button type="primary"
                   @click="modifyHandle()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 租户信息详情 -->
    <el-dialog title="租户信息详情"
               :visible.sync="detailDialog"
               width="40%"
               :before-close="cancelDetailDialog">
      <el-form class="detailForm"
               ref="detailForm"
               :model="detailForm"
               label-width="40%">
        <el-form-item label="租户名称："
                      prop="apartmentUserName">
          <span>{{ detailForm.apartmentUserName}}</span>
        </el-form-item>
        <el-form-item label="手机号："
                      prop="phone">
          <span>{{ detailForm.phone}}</span>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer"
            style="display: flex;justify-content: space-between">
        <el-button @click="cancelDetailDialog()">返 回</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import '../assets/css/TenantManagement.css'
export default {
  data() {
    return {
      apartmentCode: '',
      apartmentlist: [],
      homeList: [],
      activeName: '',
      searchForm: {},
      dataListLoading: false,
      dataList: [],
      pageIndex: 0,
      pageSize: 10,
      totalPage: 0,
      modifyDialog: false,
      modifyForm: {},
      modifyRule: {
        apartmentUserName: [
          { required: false, message: '租户名称不能为空', trigger: 'blur' },
        ],
        phone: [{ required: true, message: '手机号不能为空', trigger: 'blur' }],
      },
      detailDialog: false,
      detailForm: {},
    }
  },

  computed: {},

  created() {
    let self = this

    self.getApartmentlist()
  },

  mounted() {},

  methods: {
    handleClick(tab, event) {
      let self = this

      self.apartmentCode = tab.name

      let str = {
        apartmentCode: self.apartmentCode,
        flag: 1,
      }
      self.getHomeList(str)
    },
    // 清空查询条件
    reset() {
      let self = this
      Object.keys(self.searchForm).forEach((key) => (self.searchForm[key] = ''))
    },

    // 获取公寓列表
    getApartmentlist() {
      let self = this

      self.$axios
        ._getApartmentlist()
        .then((res) => {
          const datas = res.data

          if (datas.code == 0) {
            self.apartmentlist = datas.data

            self.activeName = self.apartmentlist[0].apartmentCode
            self.apartmentCode = self.apartmentlist[0].apartmentCode

            let str = {
              apartmentCode: self.apartmentlist[0].apartmentCode,
              flag: 1,
            }
            self.getHomeList(str)
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error(datas.msg)
        })
    },

    // 获取房间列表
    getHomeList(fristApartment) {
      let self = this

      let str = fristApartment

      self.$axios
        ._getHomelist(str)
        .then((res) => {
          const datas = res.data

          if (datas.code == 0) {
            self.homeList = datas.data.content
            self.searchForm.apartmentAssetCode =
              self.homeList[0].apartmentAssetCode

            self.getDataList('search')
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error(datas.msg)
        })
    },

    // 获取租户列表
    getDataList(type) {
      let self = this

      if (!self.searchForm.apartmentAssetCode) {
        self.$message.error('请选择房间号')
        return
      }

      self.dataListLoading = true

      if (type == 'search') {
        self.pageIndex = 0
      }

      let str = {
        apartmentCode: self.apartmentCode,
        apartmentAssetCode: self.searchForm.apartmentAssetCode,
        pageNow: self.pageIndex,
        pageSize: self.pageSize,
      }

      self.$axios
        ._getDevicelist(str)
        .then((res) => {
          const datas = res.data

          if (datas.code == 0) {
            self.dataList = datas.data.content
            self.totalPage = datas.data.totalElements
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error(datas.msg)
        })

      self.dataListLoading = false
    },

    // 每页数
    sizeChangeHandle(val) {
      let self = this

      self.pageSize = val
      self.pageIndex = 0
      self.getDataList()
    },

    // 当前页
    currentChangeHandle(val) {
      let self = this

      self.pageIndex = val
      self.getDataList()
    },

    // 打开 新增&修改弹窗
    openModifyDialog: function (row) {
      let self = this

      if (row) {
        let str = {
          apartmentCode: row.apartmentCode,
          apartmentAssetCode: row.apartmentAssetCode,
          flag: 4, // 0：所有；1：公寓租户名称；2：类型；3：状态；4：所属房间
        }
        self.$axios
          ._getUserDetail(str)
          .then((res) => {
            const datas = res.data

            if (datas.code == 0) {
              self.modifyForm = datas.data
            } else {
              self.$message.closeAll()
              self.$message.error(datas.msg)
            }
          })
          .catch((error) => {
            self.$message.closeAll()
            self.$message.error('系统异常，请联系管理员')
          })
      }

      self.modifyDialog = true
    },

    // 新增&修改
    modifyHandle: function () {
      let self = this

      let apartmentCode = self.apartmentCode
      let apartmentAssetCode = self.searchForm.apartmentAssetCode
      let phone = self.modifyForm.phone

      if (self.modifyForm.deviceCode) {
        let str = {
          apartmentCode: apartmentCode,
          apartmentAssetCode: apartmentAssetCode,
          phone: phone,
        }

        self.$axios
          ._putUserInfo(str)
          .then((res) => {
            const datas = res.data
            if (datas.code == 0) {
              self.cancelModifyDialog()
              self.getDataList('search')
              self.$message.success('修改成功')
            } else {
              self.$message.closeAll()
              self.$message.error(datas.msg)
            }
          })
          .catch((error) => {
            self.$message.closeAll()
            self.$message.error('系统异常，请联系管理员')
          })
      } else {
        let formdata = new FormData()

        formdata.append('apartmentCode', apartmentCode)
        formdata.append('apartmentAssetCode', apartmentAssetCode)
        formdata.append('phone', phone)

        self.$axios
          ._addUserInfo(formdata)
          .then((res) => {
            const datas = res.data

            if (datas.code == 0) {
              self.cancelModifyDialog()
              self.getDataList('search')
              self.$message.success('添加成功')
            } else {
              self.$message.closeAll()
              self.$message.error(datas.msg)
            }
          })
          .catch((error) => {
            self.$message.closeAll()
            self.$message.error('系统异常，请联系管理员')
          })
      }
    },

    // 关闭 新增&修改弹窗
    cancelModifyDialog: function () {
      let self = this

      Object.keys(self.modifyForm).forEach((key) => (self.modifyForm[key] = ''))
      self.$refs.modifyForm.resetFields()
      self.modifyDialog = false
    },

    // 打开 租户信息弹窗
    openDetailDialog: function (row) {
      let self = this

      if (row) {
        let str = {
          apartmentCode: row.apartmentCode,
          apartmentAssetCode: row.apartmentAssetCode,
          flag: 4, // 0：所有；1：公寓租户名称；2：类型；3：状态；4：所属房间
        }

        self.$axios
          ._getUserDetail(str)
          .then((res) => {
            const datas = res.data

            if (datas.code == 0) {
              self.detailForm = datas.data
            } else {
              self.$message.closeAll()
              self.$message.error(datas.msg)
            }
          })
          .catch((error) => {
            self.$message.closeAll()
            self.$message.error('系统异常，请联系管理员')
          })
      }

      self.detailDialog = true
    },

    // 关闭 租户信息弹窗
    cancelDetailDialog: function () {
      let self = this

      Object.keys(self.detailForm).forEach((key) => (self.detailForm[key] = ''))

      self.detailDialog = false
    },

    // 删除租户
    handleDelete(row) {
      let self = this

      let apartmentCode = row.apartmentCode
      let apartmentAssetCode = row.apartmentAssetCode

      let str = `?apartmentCode=${apartmentCode}&apartmentAssetCode=${apartmentAssetCode}`
      self
        .$confirm(`是否确认要删除 "${row.phone}" 租户`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(function () {
          return self.delDevice(str)
        })
        .then((data) => {})
    },

    delDevice(str) {
      let self = this

      self.$axios
        ._deleteUser(str)
        .then((res) => {
          const datas = res.data

          if (datas.code == 0) {
            self.$message.success('删除成功')
            self.getDataList('search')
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error(datas.msg)
        })

      self.dataListLoading = false
    },
  },
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/TenantManagement.vue